import React, { useContext, useEffect, useState } from 'react';

import './MainPage.css';
import LeftColumn from './LeftColumn/LeftColumn';
import Center from './Center/Center';

import api from '../../Utils/Api';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

const MainPage = ({ courses }) => {
  const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } =
    useContext(JourneyContext);
  const { token, setUser, user } = useContext(CurrentUserContext);
  const [performanceData, setPerformanceData] = useState(undefined);
  const [currentData, setCurrentData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCurrentPlace({ title: 'Личный кабинет ученика' });
  
        // Fetch performance data
        const performance = await api.getPerformance(token);
        

        // let data = performance.filter((el) => el.total_tests > 0);
        const limitedPerformance = performance.slice(-4);
        setPerformanceData(limitedPerformance);
        // const courses = await api.getCourses(token);
        // setPendingCourses(courses);
  
        for (const course of limitedPerformance) {
          try {
            // let f = await api.getPerformanceSpecial(token, 'course', course.id)
            // console.log(f);
            const roadMap = await api.getRoadMap(token, course.id);
            setPerformanceData((prevCourses) => {
              return prevCourses.map((prevCourse) => {
                if (prevCourse.id === course.id) {
                  return { ...prevCourse, roadMap };
                }
                return prevCourse;
              });
            });
          } catch (e) {
            console.log(e);
          } finally {
            setLoading(false);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
      setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  return (
    performanceData &&  
    <div className='mainPage__container' id='element'>
        {/* <LeftColumn courses={courses} /> */}
        <Center  performance={performanceData} loading={loading} />
    </div>
  );
};
export default MainPage;
